// @flow

export { DisplayElSalvadorianItbms } from './display-el-salvadorian-itbms';
